import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalClose } from 'client/components/Helpers/Modal';
import propTypes from 'prop-types';
import UserNewPanel from 'client/components/User/UserNewPanel';

export default class UserNewModal extends Component {

  static defaultProps = {
    open: false,
  };

  static propTypes = {
    open: propTypes.bool,
    onClose: propTypes.func.isRequired,
    onUserWasCreated: propTypes.func,
  };

  onCreated = () => {
    this.props.onClose();
    this.props.onUserWasCreated();
  };

  render () {
    const { onClose, open } = this.props;
    return (
      <Modal dialogClassName="colored-header colored-header-primary" show={open} onHide={onClose} backdrop="static">
        <Modal.Header className="modal-header">
          <ModalClose onClose={onClose} />
          <Modal.Title>Create new User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserNewPanel onCreated={this.onCreated} />
        </Modal.Body>
      </Modal>
    );
  }

}
